import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import isBuffer from 'is-buffer';
var toString = Object.prototype.toString;

var isString = function isString(val) {
  return typeof val === 'string';
};

var isNumber = function isNumber(val) {
  return typeof val === 'number';
};

var isBoolean = function isBoolean(val) {
  return typeof val === 'boolean';
};

var isUndefined = function isUndefined(val) {
  return typeof val === 'undefined';
};

var isDate = function isDate(val) {
  return toString.call(val) === '[object Date]';
};

var isFile = function isFile(val) {
  return toString.call(val) === '[object File]';
};

var isBlob = function isBlob(val) {
  return toString.call(val) === '[object Blob]';
};

var isArray = function isArray(val) {
  return toString.call(val) === '[object Array]';
};

var isObject = function isObject(val) {
  return val !== null && _typeof(val) === 'object';
};

var isFunction = function isFunction(val) {
  return typeof val === 'function';
};

var isStream = function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
};

var isArrayBuffer = function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
};

var isFormData = function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
};

var isURLSearchParams = function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
};

function isArrayBufferView(val) {
  var result;

  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }

  return result;
}

function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

var isHeaders = function isHeaders(headers) {
  return toString.call(headers) === '[object Headers]';
};

function combineURLs(baseURL, relativeURL) {
  return relativeURL ? "".concat(baseURL.replace(/\/+$/, ''), "/").concat(relativeURL.replace(/^\/+/, '')) : baseURL;
}

function queryFormat(obj) {
  return Object.entries(obj).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return value !== undefined && "".concat(key, "=").concat(encodeURIComponent(value));
  }).filter(function (item) {
    return item;
  }).join('&');
}

function addParams(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var queryString = queryFormat(params);
  return queryString.length ? "".concat(url).concat(url.includes('?') ? '&' : '?').concat(queryString) : url;
}

export { addParams, combineURLs, queryFormat, isDate, isFile, isBlob, isArray, isStream, isNumber, isString, isObject, isBuffer, isBoolean, isFormData, isFunction, isUndefined, isArrayBuffer, isURLSearchParams, isArrayBufferView, isStandardBrowserEnv, isHeaders };
//# sourceMappingURL=index.js.map